import React, { useState } from 'react';
import Filter from './filter';

const FilterWrapper = (props) => {
    const [filterObj, setFilterObj] = useState(null);

    const setFilters = (key, value) => {
        let newFilterObj = {...filterObj};
        if (value != null || (value != null && value.length > 0)) {
            newFilterObj[key] = value;
        }
        // eslint-disable-next-line no-prototype-builtins
        if ((value == null || value.length == 0) && newFilterObj.hasOwnProperty(key)) {
            delete newFilterObj[key];
        }
        setFilterObj(newFilterObj);
        props.filterData(newFilterObj);
    }

    return (
        <>
            {props.data ?
                (Object.keys(props.data)).map(key => {
                    // return(<>
                    //     <span>{'->'}{JSON.stringify(props.data[key])}</span>
                    // </>)
                    return <Filter key={key} label={key} data={props.data[key]} setFilters={setFilters} />
                })
            : null
        }
        </>
    )
}

export default FilterWrapper;